/* Landingspagina's — het weinige gedrag dat deze pagina's nodig hebben.
   ==================================================================
   Laadt alleen op een LP (layout/theme.liquid, `lp_mode`).

   Drie dingen. De eerste twee lopen op IntersectionObserver en nooit op een
   scroll-listener die per event layout leest:

   1. `[data-lp-reveal]` krijgt `.is-in` zodra het blok in beeld schuift. Dat is
      wat de gestaffelde bakjes en de tagline-woorden aanzet.
   2. `[data-lp-sticky]` verschijnt ná ongeveer één schermhoogte en verdwijnt
      zodra `#bestellen` in beeld komt.
   3. `[data-lp-cutoff]` schrijft de eerstvolgende bezorgdag in de deadline-regel.
      Dat staat hier en niet in Liquid omdat een gecachete pagina een bevroren
      datum toont — en het rekent in Amsterdamse tijd, niet in browsertijd.

   Herkomst: useReveal, LpStickyCta en LpCutoff in
   apps/sportmeals-design/src/lp.jsx (verwijderd 07-09; zie git-historie t/m 6f8e0838).
   ================================================================== */
(function () {
  'use strict'

  /* ── 1. Reveal ─────────────────────────────────────────────────────────
     Eén observer voor alle blokken, en elk blok wordt na afloop losgelaten:
     dit is een eenmalige overgang, geen toestand die heen en weer gaat. */
  /* Meldt aan de layout dat dit blok gedraaid heeft. Zonder deze vlag haalt de
     aftelling in theme.liquid `.sm-js` weer weg en wordt niets meer verborgen —
     dat is het vangnet voor een sm-lp.js die niet laadt of onderweg struikelt. */
  window.__smLpReveal = true

  var teOnthullen = document.querySelectorAll('[data-lp-reveal]')

  if (teOnthullen.length && typeof IntersectionObserver !== 'undefined') {
    var revealObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return
          e.target.classList.add('is-in')
          revealObs.unobserve(e.target)
        })
      },
      { threshold: 0.25 },
    )
    teOnthullen.forEach(function (el) {
      revealObs.observe(el)
    })
  } else {
    /* Geen IntersectionObserver: alles meteen zichtbaar. Een pagina die stil
       leeg blijft omdat een API ontbreekt is erger dan een pagina zonder
       animatie. */
    teOnthullen.forEach(function (el) {
      el.classList.add('is-in')
    })
  }

  /* ── 2. Sticky CTA ─────────────────────────────────────────────────────
     Scrollpositie in plaats van een observer op de hero-knop: niet elke LP
     hééft een hero-CTA (LP4 is een artikel), en een drempel op schermhoogte
     werkt op alle vijf de pagina's gelijk.

     rAF eromheen zodat de listener niet per scroll-event layout leest.

     ⚠ EIGEN IIFE, en dat is geen opmaak. De `return` hieronder verlaat de
     functie waar hij in staat — niet alleen dit blok. Toen alle drie de
     onderdelen nog in één IIFE zaten, doofde die ene regel stil álles wat
     erna kwam: op een pagina zonder sticky-balk (LP4 is een artikel en heeft
     er geen) werd de besteldeadline nooit ingevuld en bleef de terugvalregel
     staan. Geen foutmelding, geen spoor. Gevonden door sm-lp-cutoff.test.mjs.
     Voeg een vierde blok dus toe als een vierde IIFE, niet onderaan deze. */
})()
;(function () {
  'use strict'

  var balk = document.querySelector('[data-lp-sticky]')
  if (!balk) return

  var knop = balk.querySelector('a')
  /* De Pirates-LP heeft geen #bestellen: zijn pakketblok heet #pakketten (mail-CTA's). */
  var offer = document.querySelector('#bestellen') || document.querySelector('#pakketten')
  var offerInBeeld = false
  var wachtend = false
  var aan = null

  function meet() {
    wachtend = false
    var moetAan = window.scrollY > window.innerHeight * 0.9 && !offerInBeeld
    if (moetAan === aan) return
    aan = moetAan
    balk.classList.toggle('is-aan', moetAan)
    /* aria-hidden én tabindex samen: een knop die je niet ziet maar wel kunt
       aantabben stuurt een toetsenbordgebruiker naar een onzichtbare
       bestemming. */
    balk.setAttribute('aria-hidden', moetAan ? 'false' : 'true')
    if (knop) knop.setAttribute('tabindex', moetAan ? '0' : '-1')
  }

  function opScroll() {
    if (wachtend) return
    wachtend = true
    requestAnimationFrame(meet)
  }

  if (offer && typeof IntersectionObserver !== 'undefined') {
    new IntersectionObserver(
      function (entries) {
        offerInBeeld = entries[0].isIntersecting
        meet()
      },
      { threshold: 0 },
    ).observe(offer)
  }

  window.addEventListener('scroll', opScroll, { passive: true })
  meet()
})()
;(function () {
  'use strict'

  /* ── 3. Besteldeadline ─────────────────────────────────────────────────
     "Bestel vóór 10:00 en je hebt het woensdag 3 september in huis."

     Herkomst: LpCutoff in apps/sportmeals-design/src/lp.jsx (verwijderd 07-09). Daar stond dit in
     een useMemo op `new Date()` — dus in de tijdzone van de bezoeker. Hier niet,
     en dat verschil is het hele punt van deze functie.

     ⚠ REKEN IN AMSTERDAMSE TIJD, NIET IN BROWSERTIJD EN NIET IN UTC.
     Twee dingen gaan anders stil mis:

       · Browsertijd. Een klant die vanuit Curaçao (UTC−4) om 07:00 lokaal
         bestelt, zit in Nederland al op 13:00 en is de deadline van 10:00 dus
         ruim voorbij. Zijn scherm zegt dan "vandaag nog in huis" en dat is een
         belofte die de bezorging niet waarmaakt.
       · UTC. Van eind maart tot eind oktober loopt Nederland op UTC+2 en daarna
         op UTC+1. Een deadline die in UTC gerekend wordt, verspringt op 25-10
         stilletjes een uur mee: hij zegt "vóór 10:00" terwijl hij feitelijk om
         09:00 dichtgaat. Niets in de code verandert die dag, alleen het antwoord.

     De aanpak in twee stappen, en die volgorde is de correctie:

       1. Vraag `Intl` om de civiele datum en het uur in Europe/Amsterdam. Dat is
          het enige moment waarop de zone ertoe doet — de browser mag staan waar
          hij wil, dit leest de klok van de winkel.
       2. Tel daarna hele dagen op in UTC (`Date.UTC` + n × 86 400 000). Een
          UTC-dag is altijd 24 uur; de zondag waarop Nederland een uur springt,
          bestaat daar niet. Zou je in lokale tijd optellen, dan levert die dag
          een verschuiving van 23 of 25 uur op en slaat de telling een dag over
          of telt er één dubbel.

     Formatteren gebeurt daarom óók met `timeZone: 'UTC'`: de datum die we hier
     vasthouden ís de Amsterdamse kalenderdag, en hem alsnog door een lokale
     formatter halen zou hem opnieuw verschuiven. */
  var cutoffs = document.querySelectorAll('[data-lp-cutoff]')

  if (cutoffs.length && typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
    /* en-CA geeft ISO-achtige onderdelen (2026-08-28); we lezen ze los uit
       formatToParts, dus de opmaaktaal doet er verder niet toe. */
    var deelFmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hour12: false,
    })

    var dagFmt = new Intl.DateTimeFormat(document.documentElement.lang || 'nl-NL', {
      timeZone: 'UTC',
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    })

    /* De Amsterdamse kalenderdag als UTC-middernacht, plus het Amsterdamse uur. */
    var nu = (function () {
      var v = {}
      deelFmt.formatToParts(new Date()).forEach(function (deel) {
        v[deel.type] = deel.value
      })
      return {
        /* `hour12: false` geeft in sommige engines '24' voor middernacht. */
        uur: parseInt(v.hour, 10) % 24,
        dag: Date.UTC(parseInt(v.year, 10), parseInt(v.month, 10) - 1, parseInt(v.day, 10)),
      }
    })()

    Array.prototype.forEach.call(cutoffs, function (blok) {
      var regel = blok.querySelector('[data-lp-cutoff-regel]')
      if (!regel) return

      var uur = parseInt(blok.getAttribute('data-uur'), 10)
      if (!(uur >= 0 && uur <= 23)) return

      var dagen = (blok.getAttribute('data-dagen') || '')
        .split(',')
        .map(function (d) {
          return parseInt(d, 10)
        })
        .filter(function (d) {
          return d >= 1 && d <= 7
        })
      if (!dagen.length) return

      var hh = (uur < 10 ? '0' : '') + uur

      /* Vóór de deadline telt vandaag nog mee; erna begint de zoektocht morgen.
         Acht dagen vooruit is ruim: ook met één bezorgdag per week valt er altijd
         één binnen dat venster. Vindt hij er geen, dan blijft de fallbackregel
         staan — die is bewust altijd-waar geformuleerd. */
      var start = nu.uur < uur ? 0 : 1

      for (var i = start; i <= start + 8; i++) {
        var d = new Date(nu.dag + i * 86400000)
        var iso = d.getUTCDay() === 0 ? 7 : d.getUTCDay()
        if (dagen.indexOf(iso) === -1) continue

        regel.textContent =
          i === 0
            ? window.smT('sm.js.sm_lp.cutoff_vandaag', 'Bestel vóór %TIJD% en je hebt het vanavond in huis.').replace('%TIJD%', hh + ':00')
            : window.smT('sm.js.sm_lp.cutoff_dag', 'Bestel vóór %TIJD% en je hebt het %DAG% in huis.').replace('%TIJD%', hh + ':00').replace('%DAG%', dagFmt.format(d))
        return
      }
    })
  }
})()
